import { render, staticRenderFns } from "./InsertQtaMateriale.vue?vue&type=template&id=1dfe8f4a"
import script from "./InsertQtaMateriale.vue?vue&type=script&lang=js"
export * from "./InsertQtaMateriale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports